export default __webpack_public_path__ + "static/prioritization-8cc37da250f955bc019b0ef38f558a82.mp4";